function optionValue(dropdownField) {
    return dropdownField.value ?? dropdownField.title;
}

function optionLabel(dropdownField) {
    return dropdownField.title ?? dropdownField.value;
}

function Dropdown({ dropdownTemplate, id, defaultValue, refs, disabled }) {

    const renderFields = (dropdownTemplate) => {
        const values = (dropdownTemplate || []).map(optionValue);
        const hasMatch = defaultValue != null
            && defaultValue !== ''
            && values.some((value) => String(value) === String(defaultValue));

        return (
            <>
                {!hasMatch && defaultValue != null && defaultValue !== '' && (
                    <option value={defaultValue}>{defaultValue}</option>
                )}
                {(dropdownTemplate || []).map((dropdownField, index) => (
                    <option value={optionValue(dropdownField)} key={index}>
                        {optionLabel(dropdownField)}
                    </option>
                ))}
            </>
        );
    }

    return (
        <div className = 'dropdownWrapper'>
            {
                defaultValue !== undefined &&
                <select {...refs} id={id}
                        defaultValue={defaultValue}
                        disabled={disabled} >
                    { renderFields(dropdownTemplate) }
                </select>
            }
        </div>
    )
}

export default Dropdown;
